var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 16C31 24.2843 24.2843 31 16 31M31 16C31 7.71573 24.2843 1 16 1M31 16H1M16 31C7.71573 31 1 24.2843 1 16M16 31C12.3181 31 9.33333 24.2843 9.33333 16C9.33333 7.71573 12.3181 1 16 1M16 31C19.6819 31 22.6667 24.2843 22.6667 16C22.6667 7.71573 19.6819 1 16 1M1 16C1 7.71573 7.71573 1 16 1",
    stroke: "#8E8E93",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.7c01fb79020156ab5daf8d8bdf922103.svg";
export { ForwardRef as ReactComponent };